import { useMemoizedFn } from 'ahooks';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link, Table } from 'tdesign-react';
import ListPanel from '@/components/ListPanel';
import useTable from '@/hooks/useTable';
import { queryComponentList } from '@/services/execComponentService';
import { renderOptions } from '@/utils/common';
import { clusterTypeOptions } from '@/utils/constant';

// const { FormItem } = Form;

export default function ExecutiveComponent() {
  const navigate = useNavigate();

  const columns = [
    {
      colKey: 'name',
      title: '组件名称',
      width: 200,
      fixed: 'left',
    },
    {
      colKey: 'type',
      title: '组件类型',
      options: clusterTypeOptions,
      cell: renderOptions,
      width: 100,
    },
    {
      title: '组件作用说明',
      colKey: 'note',
    },
    {
      title: '关联集群数',
      colKey: 'clustersNum',
      width: 120,
    },
    { title: '关联机器数', colKey: 'hostsNum', width: 120 },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) => (
        <Link
          theme='primary'
          onClick={() =>
            navigate(
              `/maintenance/executive/component/detail?name=${row.name}&id=${row.id}&clusterType=${row.type}`,
            )
          }
          hover='color'
        >
          执行
        </Link>
      ),
      width: 80,
    },
  ];

  const loadData = useMemoizedFn(async (params) => {
    const { data } = await queryComponentList(params);
    setData(data.items, data.count);
  });

  const { header, config, setData, doSearch } = useTable({
    columns,
    // search: (
    //   <FormItem name='name'>
    //     <Input placeholder='组件名称' />
    //   </FormItem>
    // ),
    remote: true,
    onSearch: loadData,
  });

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  return (
    <ListPanel header='组件执行' tip='组件执行是指对组件的操作，包括新建、升级、回滚和删除操作'>
      {header}
      <Table {...config} />
    </ListPanel>
  );
}
